// extracted by mini-css-extract-plugin
module.exports = {"form":"RegistrationForm_form__3ynJP form_form__a6yyo","link":"RegistrationForm_link__3EmAX LinkNative_link__hGO0Z"};